import React from "react";

const loader = () => {
  return (
    <div style={{ height: "100vh", width: "100%", backgroundColor: "#1d4393" }}>
      <div className="progress-line"></div>
    </div>
  );
};

export default loader;
